import { Link, Outlet, ScrollRestoration } from "react-router-dom"
import { useLogout } from "~/auth/use-logout"
import { useViewerMaybe } from "~/auth/use-viewer"
import { getMetaContent } from "~/common/get-meta-content"
import {
  lettermemesPath,
  loginPath,
  myLettermemesPath,
  rootPath,
  settingsPath,
} from "~/common/paths"
import { useDocumentTitle } from "~/common/use-document-title"
import { NavProvider, useNav } from "./nav-context"

const NavBar = () => {
  const { viewer } = useViewerMaybe()
  const logout = useLogout()

  return (
    <div className="flex h-[74px] flex-row items-center justify-center border-b border-[#A9A9A9] bg-[#333] px-6 text-gray-300">
      <Link className="text-white" to={rootPath.pattern}>
        home
      </Link>
      &nbsp;|&nbsp;
      <Link className="text-white" to={lettermemesPath.pattern}>
        index
      </Link>
      {viewer ? (
        <>
          &nbsp;|&nbsp;
          <Link className="text-white" to={myLettermemesPath.pattern}>
            my lettermemes
          </Link>
          &nbsp;|&nbsp;
          <Link className="text-white" to={settingsPath.pattern}>
            profile
          </Link>
          &nbsp;|&nbsp;
          <Link
            className="text-white"
            to=""
            onClick={(e) => {
              e.preventDefault()
              logout()
            }}
          >
            logout
          </Link>
        </>
      ) : (
        <>
          &nbsp;|&nbsp;
          <Link className="text-white" to={loginPath.pattern}>
            login
          </Link>
        </>
      )}
    </div>
  )
}

const RootLayoutContent = () => {
  const { showNav } = useNav()

  return (
    <>
      <div>
        {showNav && <NavBar />}
        <Outlet />
      </div>
      <ScrollRestoration />
    </>
  )
}

export const RootLayout = () => {
  useDocumentTitle(getMetaContent("APP_NAME"))

  return (
    <NavProvider>
      <RootLayoutContent />
    </NavProvider>
  )
}
